'use strict';
require('../../../modules/es.array.flat');
require('../../../modules/es.array.unscopables.flat');
var getBuiltInPrototypeMethod = require('../../../internals/get-built-in-prototype-method');

module.exports = getBuiltInPrototypeMethod('Array', 'flat');
